export const formatNumber = (input: number): string => {
    if (input === 0) return '0';

    if (Math.abs(input) < 0.01) return parseFloat(input.toPrecision(2)).toString();

    const rounded = parseFloat(input.toFixed(1));

    return rounded % 1 === 0 ? Math.round(rounded).toString() : rounded.toString();
};
